import React from 'react'
import NavigationButton_showMore from "./actions/show-more"
import Navigation_ButtonHint from "../components/hint/hint-section";
import Navigation_BaseButton from "./base-button";

type Props = {
    className?          : string,
    inMorePopover?      : boolean
    showLabel?          : boolean
}

// const debug = "Navigation_ButtonGeneric"
const debug = false

export default class Navigation_ButtonUpgrade extends React.Component<Props> {

    public refHint                  : React.RefObject<Navigation_ButtonHint> = React.createRef<Navigation_ButtonHint>()

    showContextMenu = (e: React.MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()

        debug && console.log(debug, 'showContextMenu', e,)

        NavigationButton_showMore(e, this)
    }

    onClickUpgrade = () => {
        // gd.modals.other.upgradeToPro()
        gd.navigation.goToUpgrade()
    }

    render() {

        // let icon = 'i5-pro'

        const showLabel = this.props.showLabel !== false

        return (
            <Navigation_BaseButton className            = {this.props.className}
                                   icon                 = "i5-upgrade"
                                   label                = {showLabel ? "Upgrade" : "" }
                                   inMorePopover        = {this.props.inMorePopover}
                                   onClick              = {this.onClickUpgrade}
                                   showContextMenu      = {this.showContextMenu}>

                {!this.props.inMorePopover &&
                    <Navigation_ButtonHint ref = {this.refHint} hint="Upgrade" />
                }
            </Navigation_BaseButton>
        )
    }
}
